module.exports.globalAchievements = {
  vi: {
    title: 'Avalon: The Resistance | Thành tích toàn cầu',
    description:
      'Xem thống kê thành tích toàn cầu trong Avalon. Khám phá những thành tích hiếm nhất và phổ biến nhất của người chơi.',
    keywords: ['Thành tích', 'Thành tích toàn cầu'],
  },
  en: {
    title: 'Avalon: The Resistance | Global Achievements',
    description:
      'View global achievements statistics in Avalon Game. See which achievements are the rarest and most common among players.',
    keywords: ['achievements', 'global achievements'],
  },
  ru: {
    title: 'Авалон: Сопротивление | Глобальные достижения',
    description:
      'Просмотрите глобальную статистику достижений в Avalon Game. Узнайте, какие достижения самые редкие и самые распространенные среди игроков.',
    keywords: ['достижения', 'глобальные достижения'],
  },
  es: {
    title: 'Avalon: La Resistencia | Logros globales',
    description:
      'Ve las estadísticas de logros globales en Avalon Game. Descubre cuáles son los logros más raros y más comunes entre los jugadores.',
    keywords: ['logros', 'logros globales'],
  },
  pt: {
    title: 'Avalon: The Resistance | Conquistas globais',
    description:
      'Veja as estatísticas de conquistas globais no Avalon Game. Descubra quais conquistas são as mais raras e mais comuns entre os jogadores.',
    keywords: ['conquistas', 'conquistas globais'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 全球成就',
    description: '查看Avalon Game中的全球成就统计。了解哪些成就在玩家中最稀有和最常见。',
    keywords: ['成就', '全球成就'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 全球成就',
    description: '查看Avalon Game中的全球成就統計。了解哪些成就在玩家中最稀有和最常見。',
    keywords: ['成就', '全球成就'],
  },
};
